export const HubPageFields = Object.freeze({
  AGGREGATE_FROM: 'aggregate_from',
  HUB_NAME: 'hub_name',
  DESCRIPTION: 'description',
  EXTERNAL_WEBSITE: 'external_website',
  SELECTED_COURSE: 'selected_course',
  SPONSOR: 'sponsor',
  COURSE_ALBUM: 'course_album',
  HEADER_COLOR: 'header_color',
  PRIMARY_COLOR: 'primary_color',
  SECONDARY_COLOR: 'secondary_color',
  HEADER_LOGO_URL: 'header_logo_url',
  ROLE_TYPE: 'role_type',
  DAILY_DIGEST: 'daily_digest',
  COMMUNICATION_OFFICER_ASSIGNED: 'communication_officer_assigned',
  SELECTED_MANAGERS: 'selected_managers',
  ROLE_SETUP_FILTERS: 'role_setup_filters',
  SELECTED_CLUBS: 'selected_clubs',
  VIEW_SETTINGS: 'view_settings',
  CUSTOM_URL: 'custom_url',
  USE_LANDING_PAGE: 'use_landing_page',
  CUSTOM_TITLE: 'custom_title',
  USE_CUSTOM_GALLERY: 'use_custom_gallery',
  CUSTOM_GALLERY: 'custom_gallery',
  COACH_NOW_URL: 'coach_now_url',
  OPERATION_36_URL: 'operation_36_url',
})

export const AggregateFromValues = Object.freeze({
  NONE: 'none',
  ALL: 'all',
  CUSTOM: 'custom',
})

export const RoleTypeValues = Object.freeze({
  HUB: 'hub',
  CLUB: 'club',
  EVENTS: 'events',
  LEAGUES: 'leagues',
  CLINICS: 'clinics',
})

export const PreviewTabValues = Object.freeze({
  LANDING: 'landing',
  MAP: 'map',
  TILE: 'tile',
  LIST: 'list',
})

export const ViewSettingsFields = Object.freeze({
  ENABLE_MAP_VIEW: 'enable_map_view',
  ENABLE_CLUSTERING: 'enable_clustering',
  DEFAULT_VIEW: 'default_view',
  INCLUDE_NEXT_ROUND: 'include_next_round',
  GROUP_BY_MONTH: 'group_by_month',
  INCLUDE_ONLY_CITY: 'include_only_city',
  REPLACE_FACILITY_NAME_WITH_COURSE: 'replace_facility_name_with_course',
})

export const FilterCategoryValues = Object.freeze({
  SEASON: 'Season',
  CATEGORY: 'Category',
})

export const TemplateSettingValues = Object.freeze({
  NEW: 'new',
  TEMPLATE: 'template',
  NONE: 'none',
})

export const ClubLeagueApiFields = Object.freeze({
  AGGREGATION_TYPE: 'aggregation_type',
  HUB_ID: 'hub_id',
  FILTERS: 'filters',
  AGGREGATED_CLUBS: 'aggregated_clubs[]',
})
